/*
|--------------------------------------------------------------------------
| Component: SubmitButton.jsx
| Author: Sayed Ahmed
| Description: A customizable submit button with loading state and spinner,
|              built using React-Bootstrap and suitable for use in forms.
|--------------------------------------------------------------------------
*/

import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const SubmitButton = ({
  type = "submit", // Button type (submit/reset/button)
  form, // Optional form id (for external button)
  isLoading = false, // Whether the button is in loading state
  disabled = false, // Disable button manually
  className = "", // Extra CSS classes
  label = "Submit", // Label when not loading
  loadingLabel = "Loading...", // Label to show when loading
  children, // Optional custom inner content
  ...props // Spread any additional props
}) => {
  const { t } = useTranslation();
  return (
    <button
      type={type}
      form={form}
      disabled={isLoading || disabled}
      className={`btn btn-primary ${
        isLoading ? "opacity-75 pointer-events-none" : ""
      } ${className}`}
      {...props}
    >
      {/* Show spinner + loadingLabel when loading, else normal label */}
      {isLoading ? (
        <>
          <Spinner size="sm" animation="border" className="me-2" />
          {loadingLabel}
        </>
      ) : (
        children || t(label)
      )}
    </button>
  );
};

export default SubmitButton;
